export default {
  "activityBonusRecord.title": "活动奖金记录",
  "activityBonusRecord.column.no": "#序号",
  "activityBonusRecord.column.userNo": "会员ID",
  "activityBonusRecord.column.eventId": "活动ID",
  "activityBonusRecord.column.channel": "渠道",
  "activityBonusRecord.column.eventDetail": "活动详情",
  "activityBonusRecord.column.eventType": "活动类型",
  "activityBonusRecord.column.createTime": "创建时间",
  "activityBonusRecord.search.userNo": "会员ID",
  "activityBonusRecord.search.eventId": "活动ID",
  "activityBonusRecord.search.channel": "渠道",
  "activityBonusRecord.search.eventType": "活动类型",
  "activityBonusRecord.tooltip.copy.userNo": "复制会员ID: {text}",
  "activityBonusRecord.tooltip.copy.eventId": "复制活动ID: {text}",
  "activityBonusRecord.tooltip.showUserDetails": "显示用户详情",
  "activityBonusRecord.copy.success": "已复制到剪贴板",
};
